import React, { createContext, useContext, useState, useCallback } from "react";

interface SettingsDrawerContextType {
  open: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
}

const SettingsDrawerContext = createContext<
  SettingsDrawerContextType | undefined
>(undefined);

export const SettingsDrawerContextProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openDrawer = useCallback(() => setOpen(true), []);
  const closeDrawer = useCallback(() => setOpen(false), []);
  return (
    <SettingsDrawerContext.Provider value={{ open, openDrawer, closeDrawer }}>
      {children}
    </SettingsDrawerContext.Provider>
  );
};

export function useSettingsDrawer() {
  const ctx = useContext(SettingsDrawerContext);
  if (!ctx)
    throw new Error(
      "useSettingsDrawer must be used within SettingsDrawerContextProvider"
    );
  return ctx;
}
